module.exports = __webpack_public_path__ + "static/media/internal-server-error-bear.4c77d1f5.svg";